<as-split class="listing" direction="horizontal" [gutterSize]="18">
  <as-split-area [size]="30">

    <div class="tree-node" (click)="addNewProvider()">
      <button mat-icon-button>
        <mat-icon svgIcon="plus"></mat-icon>
      </button>
      <span class="name">New provider</span>
    </div>

    <div class="dataset-listing-tree">
      <div class="tree-node" *ngFor="let provider of providerList" (click)="providerClicked(provider.id)">
        <button mat-icon-button>
          <!--  TODO: Show icon here -->
        <mat-icon svgIcon="upload"></mat-icon>
        </button>
        <span class="name">
          {{ provider.name }}
        </span>
      </div>
    </div>
  </as-split-area>

  <as-split-area [size]="70">
    <ng-container *ngIf="selectedProviderId">
      <mood-provider-edit-form [providerId]="selectedProviderId"></mood-provider-edit-form>
    </ng-container>
  </as-split-area>
</as-split>
